// Scroll in animation logic

const isIOSSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const isScrollTriggerDisabled = document.body.classList.contains(
  "scroll-trigger-disabled"
);

const myQuantityInput = document.querySelector(".quantity__input");
myQuantityInput?.addEventListener("input", (e) => {
  const value = e.target.value;
  const reg = new RegExp("^[0-9]+$");
  if (!reg.test(value)) return (myQuantityInput.value = 0);
  if (parseInt(value) > 10) return myQuantityInput.value = 10;
});

if (isIOSSafari) {
  document.body.classList.add("scroll-trigger-disabled");
  document.querySelectorAll(".custom-animation").forEach((el) => {
    el.classList.remove("custom-animation");
    el.style.setProperty("opacity", 1, "!important");
  });
}

if (!isScrollTriggerDisabled && !isIOSSafari) {
  function onIntersection(elements, observer) {
    elements.forEach((element, index) => {
      if (element.isIntersecting) {
        element.target.classList.add("custom-animation");
      }
    });
  }
  function initializeScrollAnimationTrigger(
    rootEl = document,
    isDesignModeEvent = false
  ) {
    const observer = new IntersectionObserver(onIntersection, {
      rootMargin: "0px 0px -50px 0px",
    });
    const sections = document.querySelectorAll(".scroll-trigger");
    sections.forEach((element) => observer.observe(element));
  }

  window.addEventListener("DOMContentLoaded", () => {
    initializeScrollAnimationTrigger();
  });

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) =>
      initializeScrollAnimationTrigger(event.target, true)
    );
    document.addEventListener("shopify:section:reorder", () =>
      initializeScrollAnimationTrigger(document, true)
    );
  }
}
